module.exports = __webpack_public_path__ + "img/20200514_153208.0d3d52d9.jpg";